import { apiRegistro, apiClientGeral, apiCallCenter, apiPesquisaSatisfacao } from '@/plugins/axios'

export default {
  getRoles() {
    return apiRegistro().get('/role')
  },
  getRole(id) {
    return apiRegistro().get(`/role/${id}`)
  },
  postRoles(permission) {
    return apiRegistro().post('/role', permission)
  },
  putRoles(id, form) {
    return apiRegistro().put(`/role/${id}`, form)
  },
  deleteRole(id) {
    return apiRegistro().delete(`/role/${id}`)
  },

  getRamais() {
    return apiClientGeral().get('/ramais/lazy')
  },
  getTAGs() {
    return apiClientGeral().get('/tags/lazy')
  },
  getConferencias() {
    return apiClientGeral().get('/conferencias/lazy')
  },
  getPesquisasSatisfacao() {
    return apiPesquisaSatisfacao().get('/satisfacao/lazy')
  },
  getQueues() {
    return apiCallCenter().get('/queue/lazy')
  },
  getAgents() {
    return apiCallCenter().get('/agent/lazy')
  },
  getDepartamentos() {
    return apiCallCenter().get('/departamentos/lazy')
  },
}
